import { FC } from 'react';
import { FaIcon, MDButton } from '@components/index';

interface Props {
  onClose: () => void;
}

const CloseButton: FC<Props> = ({ onClose }) => (
  <MDButton
    size='small'
    color='white'
    sx={{
      position: 'absolute',
      right: '-40px',
      top: '0px',
      background: '#3B4147',
      borderRadius: '50%',
      height: '20px',
      width: '20px',
      minWidth: 'unset',
      border: 'none',
      zIndex: 100,
      '&:hover': { backgroundColor: '#3B4147' }
    }}
    variant='contained'
    disableRipple
    onClick={() => onClose()}
  >
    <FaIcon typographyProps={{ variant: 'sm', color: 'white' }} icon='xmark' />
  </MDButton>
);

export default CloseButton;
